export default "/build/images/aero-score-e.f1a652a5.png";